import isPropValid from '@emotion/is-prop-valid';
import merge from 'deepmerge';
import React, { useContext } from 'react';
import styled, { css, keyframes, ThemeProvider, ThemeConsumer, ThemeContext, createGlobalStyle, ServerStyleSheet } from 'styled-components';
import { getTheme } from './themes';
import { MgbTheme } from './themes/mgb';
const mergeSelectedThemeWithDefault = theme => merge(MgbTheme, theme ? typeof theme === 'string' ? getTheme(theme) : theme : {});
export const MsrcThemeProvider = ({
  children,
  theme
}) => {
  const themeContext = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: mergeSelectedThemeWithDefault(theme || (themeContext === null || themeContext === void 0 ? void 0 : themeContext.themeId))
  }, children);
};
export { ServerStyleSheet, ThemeConsumer, ThemeContext, ThemeProvider, createGlobalStyle, css, isPropValid, keyframes, styled };

/**
 * mixin for font smoothing
 * @param status if the font should be smoothed or not
 */
export const fontSmoothing = status => {
  if (status) {
    return `
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    `;
  }
  return `
    -webkit-font-smoothing: subpixel-antialiased;
    -moz-osx-font-smoothing: auto;
  `;
};
const xxsMax = `479px`;
const xsMin = `480px`;
const smMin = `768px`;
const mdMin = `992px`;
const lgMin = `1200px`;
const xsMax = `767px`;
const smMax = `991px`;
const mdMax = `1199px`;
export const sizes = {
  mobile: `(max-width: ${xxsMax})`,
  tabletAndUp: `(min-width: ${xsMin})`,
  tablet: `(min-width: ${xsMin}) and (max-width: ${xsMax})`,
  tabletAndDown: `(max-width: ${xsMax})`,
  tabletWideAndUp: `(min-width: ${smMin})`,
  tabletWide: `(min-width: ${smMin}) and (max-width: ${smMax})`,
  tabletWideAndDown: `(max-width: ${smMax})`,
  desktop: `(min-width: ${mdMin}) and (max-width: ${mdMax})`,
  desktopAndDown: `(max-width: ${mdMax})`,
  desktopAndUp: `(min-width: ${mdMin})`,
  largeDesktop: `(min-width: ${lgMin})`
};
const initialValue = {};

// https://www.styled-components.com/docs/advanced
// Iterate through the possible breakpoints and create a media template
export const media = Object.keys(sizes).reduce((acc, label) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  acc[label] = (first, ...rest) => css(["@media ", "{", "}"], sizes[label], css(first, ...rest));
  return acc;
}, initialValue);

// Get an object of just the at-media rule strings
// for use with styled-components object syntax
export const mediaForObjectSyntax = Object.keys(sizes).reduce((acc, label) => {
  acc[label] = `@media ${sizes[label]}`;
  return acc;
}, {});